<template>
  <div class="rightdetailssidebar" v-if="trigger">
    <div class="firstcontent">
      <div class="sidebar-header">
        <h6>Asset Details</h6>
        <i class="pi pi-times" @click="closetrigger()"> </i>
      </div>
      <div class="sidebar-content">
        <b-container>
          <b-form class="form-white-bg my-3" @submit.prevent="IsSubmit">
            <b-row>
              <b-col>
                <h4>{{ t('assetManagement.tracking.returnDetails') }}</h4>

                <!-- First Row: Actual Return Date -->
                <b-row class="form-row">
                  <b-col lg="6" md="6" sm="12" cols="12">
                    <div class="field">
                      <CustomDatePicker :label="t('assetManagement.tracking.expectedReturn')"
                        v-model="extendedData.AssignmentEndDate" :disabled="true"
                        :name="t('assetManagement.tracking.expectedReturn')" />
                    </div>
                  </b-col>
                </b-row>

                <!-- Second Row: Extended Return Date -->
                <b-row class="form-row">
                  <b-col lg="6" md="6" sm="12" cols="12">
                    <div class="field">
                      <CustomDatePicker :label="t('assetManagement.tracking.extendedReturnDate')"
                        v-model="extendedData.ExtendedReturnDate"
                        :name="t('assetManagement.tracking.extendedReturnDate')" />
                    </div>
                  </b-col>
                </b-row>

                <!-- Third Row: Condition -->
                <b-row class="form-row">
                  <b-col lg="6" md="6" sm="12" cols="12">
                    <div class="field">
                      <CustomDropDown :label="t('assetManagement.tracking.condition')" :items="conditionOptions"
                        v-model="extendedData.ConditionOnReturn" :name="t('assetManagement.tracking.condition')" />
                    </div>
                  </b-col>
                </b-row>

                <!-- Fourth Row: Notes (Full Width) -->
                <b-row class="form-row">
                  <b-col lg="12" md="12" sm="12" cols="12">
                    <div class="field">
                      <TextArea :name="t('assetManagement.tracking.notes')" :rows="3"
                        :label="t('assetManagement.tracking.notes')" v-model="extendedData.AssignmentNotes" />
                    </div>
                  </b-col>
                </b-row>

                <!-- Footer Row -->
                <b-row class="form-row">
                  <b-col>
                    <Footer @cancel="cancelReturn" :label="t('assetManagement.tracking.processReturn')" />
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-container>
      </div>
    </div>
  </div>

  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />


</template>
<script lang="ts">
import { defineComponent, ref, onMounted, computed, watch, nextTick } from "vue";
import Headerlayout from "../../../../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../../../../components/FormComponents/BacktoMaster.vue";
import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import CustomDropdown from "../../../../../../../../components/FormComponents/Dropdown.vue";
import TextField from "../../../../../../../../components/FormComponents/TextInput.vue";
import { useRouter, useRoute } from "vue-router";
import EditConfirmation from "../../../../../../../../components/FormComponents/EditConfirmation.vue";
import TextFieldArea from "../../../../../../../../components/FormComponents/TextArea.vue";
import AlreadyExist from "../../../../../../../../components/FormComponents/AlreadyExist.vue";
import Loader from "../../../../../../../../components/FormComponents/Loader.vue";
import MultiSelectDropDown from "../../../../../../../../components/FormComponents/MultiSelectDropdown.vue";
import Footer from "../../../../../../../../components/FormComponents/Footer.vue";
import UpdatedSuccessfully from "../../../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import Steppertabs from "../../../../../../../../components/FormComponents/Stepper.vue";
import ConfirmationTab from "../../../../../../../../components/FormComponents/CancelConfirmation.vue";
import moment from "moment";
import TextArea from "../../../../../../../../components/FormComponents/TextArea.vue";
import CustomDropDown from "../../../../../../../../components/FormComponents/Dropdown.vue";
import CustomDatePicker from "../../../../../../../../components/FormComponents/DatePicker.vue";
import AssetAssignmentService from "../../../../../../../../modules/Inventory/Service/AssetManagement/AssetAssignmentService"
export default defineComponent({
  props: {
    trigger: {
      readonly: false,
      type: Boolean,
      default: ref(false),
    },
    selectedItem: {
      type: Object,
      Default: () => { },
    },
    showButton: {
      type: Boolean,
      required: false,
    },
  },
  emits: ['close', 'update:selectedItem'],
  components: {
    CustomDatePicker,
    CustomDropDown,
    ConfirmationTab,
    TextFieldArea,
    Loader,
    AlreadyExist,
    EditConfirmation,
    BacktoPage,
    Headerlayout,
    TextField,
    CustomDropdown,
    MultiSelectDropDown,
    Footer,
    UpdatedSuccessfully,
    Steppertabs,
    TextArea
  },
  setup(props, { emit }) {
    // const store = alertEngineStore();
    const { handleSubmit, errors } = useForm();
    const showdetailrightsidebar = ref(false);
    const alreadyexistpop = ref(false);
    const successpop = ref(false);
    const confirmpop = ref(false);
    const updatepop = ref(false);
    const Editmodel = ref(false);
    const showdetails = ref(false);
    const { t } = useI18n();
    const routers = useRouter();
    const router = useRoute();
    let IDs = Number(router.query.Id);
    let getid = router.query.Id;
    let loading = ref(false);
    const sidebarwidth = computed(() => {
      return showdetails.value ? "65rem" : "35rem";
    });
    let localstoragedata = ref();
    let Entitydata = ref();
    debugger;
    Entitydata.value = localStorage.getItem("EntityData");
    Entitydata.value = JSON.parse(Entitydata.value);

    let BranchList = ref([]);
    let clientnamelist = ref([]);
    localstoragedata.value = localStorage.getItem("UsersData");
    localstoragedata.value = JSON.parse(localstoragedata.value);

    const showDialog = ref(false);
    const model: any = ref(props.selectedItem);
    let ProductsList = ref([]);
    let btnlable = ref();

    const LoadCountryStateCity = ref({
      CountryOption: [],
      StateOption: [],
      CityOption: [],
    });



    const extendedData = ref<{
      Id: number;
      UpdatedBy: string;
      UpdatedAt: string;
      AssignmentNotes: string;
      AssignmentEndDate?: string; // 👈 allow both
      ExtendedReturnDate: string;
      ConditionOnReturn: number;
    }>({
      Id: 0,
      UpdatedBy: '',
      UpdatedAt: '',
      AssignmentNotes: '',
      AssignmentEndDate: '',
      ExtendedReturnDate: '',
      ConditionOnReturn: 0,
    });
    const copyextendedData = JSON.parse(JSON.stringify(extendedData.value));


    const conditionOptions = [
      { name: t('assetManagement.tracking.conditionExcellent'), value: 1 },
      { name: t('assetManagement.tracking.conditionGood'), value: 2 },
      { name: t('assetManagement.tracking.conditionFair'), value: 3 },
      { name: t('assetManagement.tracking.conditionPoor'), value: 4 },
    ];

    onMounted(() => {
      console.log(props.selectedItem)
      if (props.selectedItem?.AssignmentEndDate) {
        console.log(props.selectedItem)
        extendedData.value.AssignmentEndDate = props.selectedItem.AssignmentEndDate;
      }
    });

    watch(() => props.trigger, (newVal) => {
      console.log(newVal)
      if (newVal && props.selectedItem?.AssignmentEndDate) {
        console.log(newVal)
        // Force update by clearing first
        extendedData.value.AssignmentEndDate = '';

        nextTick(() => {
          extendedData.value.AssignmentEndDate = props.selectedItem?.AssignmentEndDate;
          extendedData.value.Id = props.selectedItem?.Id
        });
      }
    });

    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    const IsSubmit = handleSubmit(async (values) => {

      try {

        console.log(extendedData.value)
        let msg = "";


        extendedData.value.UpdatedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );

        extendedData.value.ExtendedReturnDate = moment(extendedData.value.ExtendedReturnDate).format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );

        extendedData.value.UpdatedBy = (usersData.UserId).toString()

        const payload = { ...extendedData.value };
        delete payload.AssignmentEndDate;
        const data_response = await AssetAssignmentService.updateextendeddate(payload);
        console.log(data_response);
        msg = data_response["ErrorInfo"].ErrorCode;
        if (msg == null) {
          updatepop.value = true;
        }
      } catch (error) {
        alert(error);
      }
    });

    const closetrigger = () => {
      updatepop.value = false;
      showdetails.value = false;
      emit("close");
      cancelReturn()
    };

    const cancelReturn = () => {

      Object.assign(extendedData.value, copyextendedData);
    };





    return {
      t,
      Editmodel,
      updatepop,
      successpop,
      confirmpop,
      showDialog,

      loading,
      sidebarwidth,
      showdetailrightsidebar,
      alreadyexistpop,
      btnlable,
      conditionOptions,
      extendedData,
      LoadCountryStateCity,
      clientnamelist,
      BranchList,
      IsSubmit,
      closetrigger,
      cancelReturn
    };
  },
});
</script>
<style lang="scss" scoped>
.rightdetailssidebar {
  display: flex;
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  transition: all 0.3s ease;
  background: #ffffff;
  border: 1px solid #e1e1e1;
  z-index: 100;

  .sidebar-header {
    position: relative;
    display: flex;
    gap: 10px;
    justify-content: space-between;
    padding: 15px;
    border-bottom: 1px solid #e1e1e1;
    border-right: 1px solid #e1e1e1;

    .pi-arrow-right {
      position: absolute;
      left: -15px;
      top: 60px;
      background: #e1e1e1;
      font-size: 14px;
      height: 30px;
      width: 30px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .firstcontent {
    width: 30rem;
    flex-shrink: 0;
  }

  .secondcontent {
    width: 40rem;
    //flex-shrink: 0;
  }

  .sidebar-content {
    padding: 0px 15px 15px;
    max-height: calc(100vh - 44.8px);
    overflow: auto;
    transition: width 0.3s ease;
    flex-grow: 1;
  }
}

.form-row {
  margin-bottom: 1.5rem;
}

.field {
  margin-bottom: 1rem;
}

.form-field-column {
  margin: 8px 0px;
}

.display-field-label {
  color: #999999;
  font-size: 14px;
  line-height: 20px;
}

.details-black-field {
  color: #444444;
  font-size: 14px;
}

.small-light-txt {
  font-size: 12px;
  color: #999999;
}

.disableclass {
  pointer-events: none;
  opacity: 0.5;
}
</style>
